module.exports = __webpack_public_path__ + "media/images/home/focus-bg2-7576c9c3979c2074761158a97448f334.png";